/**
 * `/jira NOV Başlık` in the composer (docs/plans/2026-11-04-jira-design.md §4): opens "Jira işi aç"
 * with the project (a leading all-caps word) and the title filled in, instead of sending a message.
 */
export function parseJiraCommand(text) {
    const match = /^\/jira(?:\s+([\s\S]*))?$/i.exec(text.trim());
    if (!match)
        return null;
    const rest = (match[1] ?? '').trim();
    const key = /^([A-Z][A-Z0-9_]{1,19})(?:\s+([\s\S]*))?$/.exec(rest);
    return key ? { projectKey: key[1], summary: (key[2] ?? '').trim() } : { projectKey: null, summary: rest };
}
//# sourceMappingURL=commands.js.map